$(document).ready(function(){
 
  $(document).on('click','.product-filter-box',function(){
    var $this = $(this);
    var dataFilter = $this.attr('data-filter');

    $('.product-filter-box').removeClass('active-filter');
    $this.addClass('active-filter');

    $('.product-filter-select').val(dataFilter);

    $('.product-details-block-wrapper').addClass('hidden').removeClass('active-product');
    $('.product--'+dataFilter).removeClass('hidden').addClass('active-product');

    // auto scroll to next element
    var pagehandle = $('.product-details-wrapper').offset().top - 150;    
    $('html, body').animate({
      scrollTop: pagehandle
    }, 800);

  });

  $(document).on('change','.product-filter-select', function(){
    var filterVal = $(this).val();
    $('.product-details-block-wrapper').addClass('hidden').removeClass('active-product');
    $('.product--'+filterVal).removeClass('hidden').addClass('active-product');

    $('.product-filter-box').removeClass('active-filter');
    $('.product-filter-box[data-filter="'+filterVal+'"]').addClass('active-filter');

    if(filterVal==0){
      $('.product-details-block-wrapper').addClass('small-hide');
      $('.product-details-block-wrapper').eq(0).removeClass('hidden').addClass('active-product');
      $('.product-filter-box').eq(0).addClass('active-filter');
    }else{
      $('.product-details-block-wrapper').removeClass('small-hide');
    }

    // auto scroll to next element
    var pagehandle = $('.product-details-wrapper').offset().top - 150;    
    $('html, body').animate({
      scrollTop: pagehandle
    }, 800);
  });

  if(($('.gender-manner .product-filter-box').length > 2) || ($('.gender-frauen .product-filter-box').length > 2) || ($('.gender-kids .product-filter-box').length > 2)){
    const initialize_slick = setInterval(function(){
      
        
        slickCarousel();
        
        $('.product-selector-inner').append(
          `<div class="slick-nav-buttons">
            <button class="slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true">
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                </path>
              </svg>
            </button>
            <button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false">
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                </path>
              </svg>
            </button>
          </div>
          `
        );
        clearInterval(initialize_slick);
      
    },1000);
  }
  $(document).on('click','.slick-nav-buttons .slick-prev',function(){
    $('.gender-manner').find('.slick-prev').trigger('click');
    $('.gender-frauen').find('.slick-prev').trigger('click');
    $('.gender-kids').find('.slick-prev').trigger('click');
  });
  
  $(document).on('click','.slick-nav-buttons .slick-next',function(){
    $('.gender-manner').find('.slick-next').trigger('click');
    $('.gender-frauen').find('.slick-next').trigger('click');
    $('.gender-kids').find('.slick-next').trigger('click');
  });

});

function slickCarousel() {
  if($('.gender-manner .product-filter-box').length > 2){
    $('.gender-manner').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      // rows: 3,
      infinite: false,
      arrows: true,
      autoplay:false,
      swipeToSlide:true,
      touchMove: false,
       // easing:'linear',
      speed:1000,
     // touchThreshold:2, 
      // waitForAnimate:false,
      // adaptiveHeight: true
    });
  }
  if($('.gender-kids .product-filter-box').length > 2){
    $('.gender-kids').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      // rows: 3,
      infinite: false,
       // easing:'linear',
       speed:1000,
      arrows: true,   
       autoplay:false,
      // touchThreshold:2, 
      swipeToSlide:true,
        touchMove: false,
      // waitForAnimate:false,
      // adaptiveHeight: true
    });
  }
  if($('.gender-frauen .product-filter-box').length > 2){
    $('.gender-frauen').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      // rows: 3,
      infinite: false,
       // easing:'linear',
       speed:1000,
      arrows: true, 
       autoplay:false,
      // touchThreshold:2, 
        touchMove: false,
      swipeToSlide:true,
      // waitForAnimate:false,
      // adaptiveHeight: true
    });
  }
}